module.exports = __webpack_public_path__ + "s.no2.e3bd4982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s.no2.jpg
// module id = 3JkG
// module chunks = 0